import {api} from "../../shared/utils";
import {extractListPayload} from "../../shared/utils/payload";
import {environment} from "../../config/environment";

const baseUrl = environment.apiBaseURLClients;

// Cadastro de métricas do app-funcionalidades (BBF-149). O apontamento no sistema vai no PUT /sistemas/{id}.

// Páginas de 100 (o máximo da API) até `has_next` acabar.
export const listMetricas = async (params = {}) => {
    const items = [];
    for (let page = 1; ; page += 1) {
        const query = new URLSearchParams({sortBy: 'nome', order: 'asc', ...params, page: String(page), pageSize: '100'});
        const response = await api.get(`${baseUrl}/metricas?${query.toString()}`);
        const pagina = extractListPayload(response).items;
        items.push(...pagina);
        const raiz = response?.data?.valor ?? response?.data?.data ?? response?.data;
        if (!pagina.length || !raiz?.pagination?.has_next) break;
    }
    return items;
};

export const getMetrica = (id) => api.get(`${baseUrl}/metricas/${id}`);

// O POST não devolve a métrica criada: o id sai da busca pela chave, que é única.
export const createMetrica = (payload) => api.post(`${baseUrl}/metricas`, payload);

// O PUT é parcial: o que não vem fica como está.
export const updateMetrica = (id, payload) => api.put(`${baseUrl}/metricas/${id}`, payload);

export const deleteMetrica = (id) => api.delete(`${baseUrl}/metricas/${id}`);

// O sistema traz os apontamentos (`metricas`), com fonte e como mede; a versão traz os limites (BBF-153).
export const getSistema = (id) => api.get(`${baseUrl}/sistemas/${id}`);

export const getVersaoDoPlano = (planoId, numero) => api.get(`${baseUrl}/planos-licenciamento/${planoId}/versoes/${numero}`);
